import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

/** The one serialiser shape both small document writers use: schema + personKey + items, indent 1. */
export class AppDocJson {
    public static Of<TItem>(Items: TItem[], ItemOf: (One: TItem) => Record<string, unknown>,
                            Schema: number, PersonKey: string, Label: string): string {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Out: Record<string, unknown>[] = [];
            for (const One of Items) { Out.push(ItemOf(One)); }
            return JSON.stringify({ schema: Schema, personKey: nz(PersonKey), items: Out }, null, 1);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, Label);
            return "";
        }
    }
}
